// Build the server-side click-tracking redirect URL for a broker.
// The raw affiliate URL stays on the backend; this route logs the click then 302s.
export function brokerGoUrl(slug, src = "", userId = "") {
  const base = process.env.REACT_APP_BACKEND_URL || "";
  const params = new URLSearchParams();
  if (src) params.set("src", src);
  if (userId) params.set("u", userId);
  const q = params.toString();
  return `${base}/api/go/broker/${slug}${q ? `?${q}` : ""}`;
}
